const panelTransitionDurationMs = 275;
const wrapperCls = "c2lwpteypm";
const headingCls = "c2lh2imrlu";
const transitionWrapperCls = "c2lt193tyce";
const panelTransitionCls = "c2lp2zz49w";

export { headingCls, panelTransitionCls, panelTransitionDurationMs, transitionWrapperCls, wrapperCls };
import "./_share-drawer.style.linaria.module.css";
//# sourceMappingURL=_share-drawer.style.js.map
